@if (!this.isGameSelected()) {
  <div style="text-align: center;">
    <h2>{{ 'components.home.title' | transloco }}</h2>
    <app-button-toggle-group>
      <mat-button-toggle-group aria-label="Filter">
        <mat-button-toggle data-testid="statusFilterAll" [checked]="statusFilter() === GameStatusFilter.All" (click)="selectStatusFilter(GameStatusFilter.All)">{{ 'components.home.filterAll' | transloco }}</mat-button-toggle>
        <mat-button-toggle data-testid="statusFilterScheduled" [checked]="statusFilter() === GameStatusFilter.Scheduled" (click)="selectStatusFilter(GameStatusFilter.Scheduled)">{{ 'components.home.filterScheduled' | transloco }}</mat-button-toggle>
        <mat-button-toggle data-testid="statusFilterInProgress" [checked]="statusFilter() === GameStatusFilter.InProgress" (click)="selectStatusFilter(GameStatusFilter.InProgress)">{{ 'components.home.filterInProgress' | transloco }}</mat-button-toggle>
        <mat-button-toggle data-testid="statusFilterCompleted" [checked]="statusFilter() === GameStatusFilter.Completed" (click)="selectStatusFilter(GameStatusFilter.Completed)">{{ 'components.home.filterCompleted' | transloco }}</mat-button-toggle>
      </mat-button-toggle-group>
    </app-button-toggle-group>
    <div data-testid="game-list">
      @for (gameInfo of gamesInfo(); track gameInfo) {
        <div>
          <mat-card class="mat-elevation-z2"
            [class.demo]="gameInfo.id === 'Démo'"
            [attr.data-testid]="gameInfo.id === 'Démo' ? 'demoGame' : gameInfo.id"
            (click)="game.selectGame(gameInfo)">
            <div class="logo-wrap">
              <div class="logo">
                <img alt="Logo {{ gameInfo.homeTeam.teamName }}" src="{{ gameInfo.homeTeam.teamLogoUrl }}">
              </div>
              @if (showScore(gameInfo)) {
                <div class="score" data-testid="homeScore">{{ gameInfo.homeScore }}</div>
              }
            </div>
            <div class="game-info">
              @if (gameInfo.gameType === GameType.Exhibition) {
                <div class="exhibition-tag" data-testid="exhibitionTag">{{ 'components.home.exhibitionTag' | transloco }}</div>
              }
              <div class="date">
                @if (gameInfo.id === 'Démo') {
                  <div>
                    {{ 'components.home.demoGame' | transloco }}
                  </div>
                }
                {{ gameInfo.gameDate | date:'y-MM-dd' }} &nbsp; {{ gameInfo.gameStatus }}
              </div>
              <div class="game-teams-name">
                <div class="team home">
                  {{ gameInfo.homeTeam.teamName }}
                </div>
                <div class="center">|</div>
                <div class="team away">
                  {{ gameInfo.awayTeam.teamName }}
                </div>
              </div>
            </div>
            <div class="logo-wrap">
              @if (showScore(gameInfo)) {
                <div class="score" data-testid="awayScore">{{ gameInfo.awayScore }}</div>
              }
              <div class="logo">
                <img alt="Logo {{ gameInfo.awayTeam.teamName }}" src="{{ gameInfo.awayTeam.teamLogoUrl }}">
              </div>
            </div>
          </mat-card>
        </div>
      }
    </div>
  </div>
}
